import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

export interface ScriptNameDialogData {
  title: string;
}

export interface ScriptNameDialogResult {
  title: string;
}

@Component({
  selector: 'app-script-name-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './script-name-dialog.component.html',
  styleUrl: './script-name-dialog.component.less'
})
export class ScriptNameDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ScriptNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ScriptNameDialogData
  ) {
    this.form = this.fb.group({
      title: [data.title || '', [Validators.required, Validators.minLength(1)]]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.form.valid) {
      const result: ScriptNameDialogResult = {
        title: this.form.get('title')?.value
      };
      this.dialogRef.close(result);
    }
  }
}
